/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import MoreButton from '@components/navbar/MoreButton';

import SubdistributorScreen from '@/screens/subdistributor/SubdistributorScreen';
import SubdistributorFormScreen from '@/screens/subdistributor/SubdistributorFormScreen';
import SubdistributorDetailScreen from '@/screens/subdistributor/SubdistributorDetailScreen';
const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const SubdistributorNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="SubdistributorScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="SubdistributorScreen"
        component={SubdistributorScreen}
        options={(props) => ({
          title: setTitleHeader('Sub-Distributor'),
          hideScroll: true,
        })}
      />
      <Stack.Screen
        name="SubdistributorFormScreen"
        component={SubdistributorFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Register New Outlet';
          if (route.params && route.params.titleScreen) {
            title = 'Edit Outlet';
          }
          const goBack = () => {
            if (route.params && route.params.titleScreen) {
              props.navigation.navigate(
                'SubdistributorDetailScreen',
                route.params,
              );
            } else {
              props.navigation.navigate('SubdistributorScreen');
            }
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="SubdistributorDetailScreen"
        component={SubdistributorDetailScreen}
        options={(props) => {
          const hasAccess = !hasNoAccess([
            'superadmin',
            'general',
            'regional_manager',
            'regional_support',
            'key_account_manager',
            'group_key_account_manager',
            'national_key_account_manager',
            'marketing_admin',
            'chief_of_staff',
          ]);
          const route = props.route;
          let title = 'Sub-Distributor Detail';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }

          const menus = [];
          if (hasAccess) {
            menus.push({
              type: 'redirect',
              name: 'Edit',
              screen: 'SubdistributorFormScreen',
              params: route.params,
            });
          }
          const goBack = () => {
            props.navigation.navigate('SubdistributorScreen');
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : menus.length > 0 ? (
                <MoreButton menu={menus} {...props} />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default SubdistributorNavigator;
